(() => {
    if (window.location.hostname === 'prod-b2b.gls-pakete.de') {
        window.location = window.location.toString().replace('https://prod-b2b.gls-pakete.de', 'https://www.gls-pakete.de')
    }

    if (window.location.hostname === 'staging-b2b.gls-pakete.de') {
        window.location = window.location.toString().replace('https://staging-b2b.gls-pakete.de', 'https://staging.gls-pakete.de')
    }
}) ()
